module.exports = __webpack_public_path__ + "static/img/404.abd3097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.png
// module id = 1366
// module chunks = 0